import { useState } from 'react';

import { useAppNavigation } from '../../../hooks/useAppNavigation';

import { CreateMeal } from './CreateMeal';

import { AdaptiveModal } from '../AdaptiveModal';

const FULL_STYLE = {
  minWidth: '320px',
  width: '940px',
  maxWidth: '96vw',
  height: '720px',
  maxHeight: '85vh',
  padding: 0
};
const COMPACT_STYLE = {
  minWidth: '320px',
  width: '460px',
  maxWidth: '96vw',
  height: 'auto',
  maxHeight: '85vh',
  padding: 0
};

export const CreateMealModal = () => {
  const { showCreateMealModal, setShowCreateMealModal } = useAppNavigation();
  const [compact, setCompact] = useState(false);

  return (
    <AdaptiveModal
      open={showCreateMealModal}
      onOpen={setShowCreateMealModal}
      background="background-secondary"
      contentStyle={compact ? COMPACT_STYLE : FULL_STYLE}
      mobileAutoHeight={compact}
      mobileFullHeight={!compact}
      mobileFlush
    >
      <CreateMeal onCompactChange={setCompact} />
    </AdaptiveModal>
  );
};
